import * as yup from 'yup';
import { RadiatorVentingDuration } from '@lib/api';
import { ExtendedUpdateRadiatorVentingStatusRequest, Reason } from './ValveVentingComponent';

export const ValveVentingSchema: yup.ObjectSchema<ExtendedUpdateRadiatorVentingStatusRequest> = yup.object({
  isVentingPossible: yup.boolean().required(),

  success: yup
    .object({
      duration: yup.mixed<RadiatorVentingDuration>().oneOf(['None', 'Minimal', 'Moderate', 'High', 'Maximum']).required(),
    })
    .when('isVentingPossible', {
      is: true,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.strip(),
    }),

  failure: yup
    .object({
      reason: yup.mixed<Reason>().oneOf(['radiatorNotAccessible', 'valvePinBlocked', 'otherIssue']).required(),
      comment: yup.string().optional(),
      radiatorNotAccessible: yup.boolean().default(false).required(),
      valvePinBlocked: yup.boolean().default(false).required(),
      otherIssue: yup.boolean().default(false).required(),
    })
    .when('isVentingPossible', {
      is: false,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.strip(),
    }),
});
